import { render, staticRenderFns } from "./SearchPackage.vue?vue&type=template&id=1dc94bcc&scoped=true&"
import script from "./SearchPackage.vue?vue&type=script&lang=js&"
export * from "./SearchPackage.vue?vue&type=script&lang=js&"
import style0 from "./SearchPackage.vue?vue&type=style&index=0&id=1dc94bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc94bcc",
  null
  
)

export default component.exports